
export function dateTransform(value: Date | number | undefined, _obj: any, type: number): number | Date | undefined {
    if (type === 0) {
        return value ? new Date(value) : undefined;
    } else {
        return value ? Math.round((value as Date).getTime()) : undefined;
    }
}

/**
 * Merge function to replace Object.assign with deep merging possibility
 * 
 * https://github.com/oruga-ui/oruga/blob/develop/packages/oruga/src/utils/helpers.js
 */
const isObject = (item: any) => typeof item === 'object' && !Array.isArray(item)
const mergeFn = (target: any, source: any, deep = false): any => {
    if (deep || !Object.assign) {
        const isDeep = (prop: any) =>
            isObject(source[prop]) &&
            target !== null &&
            Object.prototype.hasOwnProperty.call(target, prop) &&
            isObject(target[prop])
        let replaced
        if (source === null || typeof source === 'undefined') {
            replaced = {};
        } else {
            replaced = Object.getOwnPropertyNames(source)
                .map((prop) => ({
                    [prop]: isDeep(prop)
                        ? mergeFn(target[prop], source[prop], deep)
                        : source[prop]
                }))
                .reduce((a, b) => ({ ...a, ...b }), {})
        }
        return {
            ...target,
            ...replaced
        }
    } else {
        return Object.assign(target, source)
    }
}
export const merge = mergeFn

export function getUrlParameter(name: string) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}